import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newShippingline() {
    let shippinglineDetails = {
      shipping_name: $(".shipping_name").val(),
      free_days: $(".free_days").val(),
      oog: $('.oog').val()
    };
    $(".creatingShippingline").hide();
    $(".creatingShippinglineLoader").show();
    baseurl.post(rt.newShippinglines, shippinglineDetails).then(res => {
      $(".creatingShippingline").show();
      $(".creatingShippinglineLoader").hide();
      $(".form-control").val("");

      //checking responses codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.shippinglineCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //shippingline exists
        ers.ShippinglineExists();
      } else if (res.data.code === 404) {
        //error on creating shipping line
        ers.errorCreatingShippingline();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        setTimeout(() => {
          router.push("/dashboard");
        }, 2000);
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  loadShippinglines({ commit }) {
    baseurl.get(rt.loadShippinglines).then(res => {
      $(".shippinglinesLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and committinf to mutations
        commit("STORE_SHIPPINGLINES", res.data.shippinglines);
      } else if (res.data.code === 404) {
        //error on loading shipping lines data
        ers.errorLoadingShippinglines();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_SHIPPINGLINES", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewShippingline({ commit }, shippinglineId) {
    commit("STORE_SHIPPINGLINE_UPDATE", shippinglineId);
    router.push("/updateshippingline");
  },

  shippinglineUpdate({ commit }) {
    let shippinglineDetails = {
      id: $(".id").val(),
      shipping_name: $(".shipping_name").val(),
      free_days: $(".free_days").val(),
      oog: $('.oog').val()
    };
    $(".updatingShippingline").hide();
    $(".updatingShippinglineLoader").show();
    baseurl.post(rt.updateShippingline, shippinglineDetails).then(res => {
      $(".updatingShippingline").show();
      $(".updatingShippinglineLoader").hide();

      //checking response codes from backend api
      if (res.data.code === 200) {
        //success code
        suc.shippinglineUpdateSuccess();
        commit("STORE_SHIPPINGLINES", res.data.shippinglines);
        setTimeout(() => {
          router.push("/manageshippinglines");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating shipping line recors
        ers.errorUpdatingShippingline();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        setTimeout(() => {
          router.push("/dashboard");
        }, 2000);
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/shippinglines/actions.js